import { render, staticRenderFns } from "./selectedBox.vue?vue&type=template&id=171805e7&"
import script from "./selectedBox.vue?vue&type=script&lang=js&"
export * from "./selectedBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports